import { observable } from "mobx";
import { Type } from "class-transformer";
import ChargeChangeInitiator from "entities/chargeChangeInitiator";
import ChargeChangeOrigin from "entities/chargeChangeOrigin";
import ChargeChangeResponse from "./chargeChangeResponse";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class ChargeHistoryResponse {
  @observable
  @Type(() => Date)
  changedAt!: Date;

  @observable
  @Type(() => ChargeChangeResponse)
  changes!: ChargeChangeResponse[];

  @observable
  changeInitiator!: ChargeChangeInitiator;

  @observable
  changedBy?: string;

  @observable
  changeOrigin!: ChargeChangeOrigin;

  @observable
  officialRecordId?: string;

  @observable
  wasMadeByCustomerDuringValidity!: boolean;
}
